import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
export var addressLabel = function(value) {
    var language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "th";
    if (!value) return "";
    try {
        var names = typeof value === "string" ? JSON.parse(value) : value;
        return (names === null || names === void 0 ? void 0 : names[language]) || (names === null || names === void 0 ? void 0 : names.th) || (names === null || names === void 0 ? void 0 : names.lo) || (names === null || names === void 0 ? void 0 : names.la) || (names === null || names === void 0 ? void 0 : names.en) || String(value);
    } catch (e) {
        return String(value);
    }
};
export function useAddressRows(handler, reducerName, provinceid, districtid) {
    var enabled = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    var dispatch = useAppDispatch();
    var key = JSON.stringify([
        provinceid,
        districtid
    ]);
    var state = useAppSelector(function(store) {
        return store[reducerName];
    });
    useEffect(function() {
        if (enabled) {
            dispatch(handler({
                provinceid: provinceid,
                districtid: districtid
            }));
        }
    }, [
        dispatch,
        handler,
        provinceid,
        districtid,
        enabled
    ]);
    return enabled && (state === null || state === void 0 ? void 0 : state.key) === key ? {
        rows: state.data || [],
        loading: state.isFetching,
        error: state.isError
    } : {
        rows: [],
        loading: enabled,
        error: false
    };
}
export default function AddressSelect(param) {
    var label = param.label, value = param.value, onChange = param.onChange, source = param.source, idKey = param.idKey, nameKey = param.nameKey, disabled = param.disabled, required = param.required, error = param.error, _param_language = param.language, language = _param_language === void 0 ? "th" : _param_language;
    var options = source.rows.map(function(row) {
        return {
            value: row[idKey],
            label: addressLabel(row[nameKey], language),
            row: row
        };
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "col-xl-4 col-md-12",
        children: /*#__PURE__*/ _jsxs(Form.Group, {
            className: "mb-2 form-st-3",
            children: [
                /*#__PURE__*/ _jsxs(Form.Label, {
                    className: "mb-1",
                    children: [
                        label,
                        required && /*#__PURE__*/ _jsx("span", {
                            className: "text-danger",
                            children: " *"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Select, {
                    "aria-label": label,
                    "aria-required": required,
                    "aria-invalid": !!error,
                    className: "w-100 select-st-3",
                    options: options,
                    value: options.find(function(option) {
                        return String(option.value) === String(value);
                    }) || null,
                    onChange: onChange,
                    placeholder: "เลือก".concat(label),
                    isClearable: true,
                    isLoading: source.loading,
                    isDisabled: disabled || source.loading,
                    noOptionsMessage: function() {
                        return source.error ? "โหลดข้อมูลไม่สำเร็จ กรุณาโหลดหน้าใหม่" : "ไม่พบข้อมูล";
                    },
                    menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
                    menuPosition: "fixed",
                    styles: {
                        menuPortal: function(base) {
                            return _object_spread_props(_object_spread({}, base), {
                                zIndex: 9999
                            });
                        }
                    }
                }),
                error && /*#__PURE__*/ _jsx("div", {
                    className: "text-danger small",
                    children: error
                }),
                source.error && /*#__PURE__*/ _jsxs("div", {
                    className: "text-danger small",
                    children: [
                        "โหลด",
                        label,
                        "ไม่สำเร็จ กรุณาโหลดหน้าใหม่"
                    ]
                })
            ]
        })
    });
}
